import { TFunction } from 'i18next'
import { BooleanSchema, boolean } from 'yup'

import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const checkboxSchema = (
  t: TFunction<'translation', undefined>,
): BooleanSchema<boolean | undefined> =>
  boolean().required(t(formTranslation.errors.fieldRequired))
